import { render, staticRenderFns } from "./InputFileField.vue?vue&type=template&id=3de4aa3d&scoped=true"
import script from "./InputFileField.vue?vue&type=script&lang=js"
export * from "./InputFileField.vue?vue&type=script&lang=js"
import style0 from "./InputFileField.vue?vue&type=style&index=0&id=3de4aa3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de4aa3d",
  null
  
)

export default component.exports